<template>
    <div class="guide-title-container">
        <img
            src="../assets/images/ico-back-n.png"
            class="btn-back"
            @click="OnClickBack"
        >
        <template v-if="step > 0">
            <div class="dot" :class="getStyleForDot(1)"></div>
            <div class="dot" :class="getStyleForDot(2)"></div>
            <div class="dot" :class="getStyleForDot(3)"></div>
        </template>
    </div>
</template>
<script>
    export default {
        components: {
        },
        data() {
            return {
            }
        },
        props: {
            step: {
                type: Number,
                required: true
            },
            back: {
                type: String,
                required: false
            }
        },
        computed: {
        },
        methods: {
            getStyleForDot(step) {
                if(this.step === step)
                    return 'active'
                return ''
            },
            OnClickBack() {
                if(this.back) {
                    this.$router.push(this.back)
                } else {
                    this.$router.go(-1)
                }                
            }
        },
        mounted() {
        }
    }
</script>
<style scoped>
    .guide-title-container {
        text-align: center;
        height: 28px;
        line-height: 28px;
        vertical-align: middle;
        margin-bottom: 7px;
        position: relative;
        background-color: white;
    }
    .btn-back {
        display: inline;
        position: absolute;
        left: 10px;
        width: 28px;
    }
    .dot {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #aeaeae;
        margin: 0 10px;
        transition: background-color 300ms, width 300ms, height 300ms;
    }
    .dot.active {
        background-color: #3f6fff;
        width: 12px;
        height: 12px;
    }
</style>